<template>
    <div class="bodyheight grid bg-gray-100 dark:bg-black relative">
        <bg-global :bgLobby="bgLobby" />

        <ul class="bodyheight overflow-auto flex flex-col gap-1 py-2 text-black dark:text-gray-100 z-10">
            <div class="uppercase text-center font-semibold mb-2">Revenue</div>
            <div v-if="fetching" class="my-1 flex items-center justify-center gap-2">
                <span class="text-sm text-gray-100">Fetching...</span>
                <spinner />
            </div>

            <div v-if="!fetching" class="flex flex-col items-center justify-center gap-1 mb-4">
                <button
                    @click.prevent="claim"
                    type="button"
                    :disabled="claiming || totalAmount < minAmount"
                    class="claim-button"
                >
                    <div v-if="claiming" class="flex items-center justify-center gap-2">
                        <span class="uppercase">Claiming</span>
                        <spinner />
                    </div>
                    <div v-else>
                        <div v-if="totalAmount > 0" class="flex items-center justify-center gap-1">
                            <span class="uppercase">Claim ~<span class="font-semibold">{{ lamportsToSol(totalAmount, 4) }}</span></span>
                            <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                        </div>
                        <div v-else class="uppercase">
                            Nothing to Claim
                        </div>
                    </div>
                </button>
                <div v-if="totalAmount > 0" class="text-xs text-white flex items-center">
                    <div>Unrounded amount: </div>
                    <span class="font-semibold">{{ lamportsToSol(totalAmount) }}</span>
                    <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                </div>
                <div class="text-sm text-inner-border">There's a minimum of {{ lamportsToSol(minAmount, 2) }} SOL to be able to Claim!</div>
            </div>

            <div v-if="!fetching && sponsor" class="uppercase text-center font-semibold mb-2 text-xs">Sponsor Revenue</div>
            <div v-if="!fetching && sponsor" class="flex items-center justify-between mx-2 mb-4">
                <div class="">{{ sponsor.name }}</div>
                <div class="flex items-center justify-center gap-1">
                    <span class="text-base font-semibold">~{{ lamportsToSol(sponsorAmount, 5) }}</span>
                    <img src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                </div>
            </div>

            <div v-if="!fetching" class="uppercase text-center font-semibold mb-2 text-xs">SBG Revenue</div>
            <li
                v-for="(nft, index) in nfts"
                class="flex flex-col mx-2 py-1 px-2 rounded text-sm"
                :class="index % 2 == 0 ? 'bg-black bg-opacity-10 dark:bg-white dark:bg-opacity-10' : 'dark:bg-white dark:bg-opacity-5'"
            >
                <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                        <img class="h-6 w-6 rounded-full" :src="nft.image" />
                        <span class="text-sm">{{ nft.name }}</span>
                    </div>
                    <div class="flex items-center gap-1">
                        <span v-if="nft.amount > 0" class="font-semibold">~{{ lamportsToSol(nft.amount, 5) }}</span>
                        <span v-else>&mdash;</span>
                        <img v-if="nft.amount > 0" src="/images/sol.png" class="block h-4 w-4 rounded-full" />
                    </div>
                </div>
            </li>
            <li v-if="!fetching && !nfts.length" class="flex items-center justify-center text-sm text-red-400 dark:text-red-200 italic text-center">
                No SBGs found in your wallet! In order to be eligible for revenue share, you need to be a SBG Holder!
            </li>
        </ul>
    </div>
</template>

<script>
import solana from '../mixins/solana'
export default {
    name: 'RevenueShare',
    props: [ 'token', 'bgLobby' ],
    mixins: [ solana ],
    data() {
        return {
            minAmount: parseInt(process.env.MIX_MIN_CLAIM_AMOUNT, 10),
            fetching: false,
            claiming: false,
            nfts: [],
            sponsor: null,
        }
    },
    async mounted() {
        await this.getRevenues()
    },
    computed: {
        totalAmount() {
            return this.sponsorAmount + this.nftsAmount
        },
        sponsorAmount() {
            if (this.sponsor === null) {
                return 0
            }
            return this.sponsor.amount
        },
        nftsAmount() {
            return this.nfts.reduce((sum, obj) => sum + parseInt(obj.amount, 10), 0)
        }
    },
    methods: {
        async getRevenues() {
            this.fetching = true
            axios.post('/api/account/revenue/show', null, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((res) => {
                this.nfts = res.data.data.nfts
                this.sponsor = res.data.data.sponsor
            }).catch((err) => {
                console.log(err.message)
                this.$toast.error(err.message)
            }).then(() => {
                this.fetching = false
            })
        },
        async claim() {
            this.claiming = true
            axios.post('/api/account/revenue/claim', null, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).then((res) => {
                this.$toast.success('Claim Successful!')
                this.claiming = false
                this.nfts = []
                this.sponsor = null
                this.getRevenues()
            }).catch((err) => {
                if (err.response) {
                    this.$toast.error(err.response.data.message)
                }
                console.log(err, err.message)
            }).then(() => {
                this.claiming = false
            })
        }
    }
}
</script>
